module.exports = __webpack_public_path__ + "img/check-mark-1.dae7b259.svg";